import { auth } from '@/firebase'
import api from '@/api'

function onAuthStateChanged (callback) {
  return auth.onAuthStateChanged((user) => {
    callback(user)
  })
}

function get (ref, success, error) {
  return onAuthStateChanged((user) => {
    api.get(ref(user), success, error)
  })
}

function subscribe (ref, callbacks, success, error) {
  let subscription = null
  return onAuthStateChanged((user) => {
    if (subscription) subscription()
    subscription = api.subscribe(ref(user), callbacks, success, error)
  })
}

function logout () {
  return auth.signOut()
}

function requireLogin (f, error) {
  const user = auth.currentUser
  if (user) {
    return f(user)
  } else {
    return error()
  }
}

export default {
  get,
  subscribe,
  user () { return auth.currentUser },
  changed: onAuthStateChanged,
  logout,
  require: requireLogin
}



// WEBPACK FOOTER //
// ./src/api/auth.js